module.exports = "/_next/static/images/1c64f0fa5640dc2d18b4daa9e8252f7f-woman-using-cellphone@0.5x.jpg";